var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "menu-template-manage-container" },
    [
      _c(
        "el-card",
        { staticClass: "scene-control-card", attrs: { shadow: "hover" } },
        [
          _c(
            "div",
            {
              staticClass: "card-header",
              staticStyle: {
                display: "flex",
                "justify-content": "space-between",
                "align-items": "center",
              },
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "div",
                { staticClass: "config-options" },
                [
                  _c("el-input", {
                    staticClass: "filter-item",
                    staticStyle: { width: "200px" },
                    attrs: { placeholder: "门店名称", clearable: "" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.handleStoreFilter($event)
                      },
                    },
                    model: {
                      value: _vm.storeQuery.keywords,
                      callback: function ($$v) {
                        _vm.$set(_vm.storeQuery, "keywords", $$v)
                      },
                      expression: "storeQuery.keywords",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      directives: [{ name: "waves", rawName: "v-waves" }],
                      staticClass: "filter-item",
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.handleStoreFilter },
                    },
                    [_vm._v("\n          搜索\n        ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "scene-actions" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [{ name: "waves", rawName: "v-waves" }],
                      staticClass: "filter-item",
                      attrs: {
                        size: "medium",
                        type: "success",
                        icon: "el-icon-view",
                      },
                      on: { click: _vm.handlePreviewStoreMenu },
                    },
                    [_vm._v("\n          预览\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      directives: [{ name: "waves", rawName: "v-waves" }],
                      staticClass: "filter-item",
                      attrs: {
                        size: "medium",
                        type: _vm.isAllSelected ? "info" : "primary",
                        icon: _vm.isAllSelected
                          ? "el-icon-close"
                          : "el-icon-check",
                      },
                      on: { click: _vm.handleSelectAll },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.isAllSelected ? "取消全选" : "全选") +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      directives: [{ name: "waves", rawName: "v-waves" }],
                      staticClass: "filter-item",
                      attrs: { type: "primary", icon: "el-icon-folder-add" },
                      on: {
                        click: function ($event) {
                          return _vm.handleBatchChangeStatus(1)
                        },
                      },
                    },
                    [_vm._v("\n          批量上架\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      directives: [{ name: "waves", rawName: "v-waves" }],
                      staticClass: "filter-item",
                      attrs: { type: "warning", icon: "el-icon-folder-remove" },
                      on: {
                        click: function ($event) {
                          return _vm.handleBatchChangeStatus(0)
                        },
                      },
                    },
                    [_vm._v("\n          批量下架\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      directives: [{ name: "waves", rawName: "v-waves" }],
                      staticClass: "filter-item",
                      attrs: { type: "warning", icon: "el-icon-folder-add" },
                      on: { click: _vm.handleCache },
                    },
                    [_vm._v("\n          缓存\n        ")]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "main-content" }, [
            _c(
              "div",
              {
                staticClass: "store-panel",
                class: { collapsed: _vm.storePanelCollapsed },
              },
              [
                _c("div", { staticClass: "panel-header" }, [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.storePanelCollapsed,
                          expression: "!storePanelCollapsed",
                        },
                      ],
                    },
                    [_vm._v("门店选择")]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.storePanelCollapsed,
                          expression: "storePanelCollapsed",
                        },
                      ],
                      staticClass: "vertical-text",
                    },
                    [_vm._v("门店")]
                  ),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "collapse-icon",
                    class: _vm.storePanelCollapsed
                      ? "el-icon-d-arrow-right"
                      : "el-icon-d-arrow-left",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.toggleStorePanel($event)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.storePanelCollapsed,
                        expression: "!storePanelCollapsed",
                      },
                    ],
                    staticClass: "panel-subheader",
                  },
                  [_vm._v("门店列表")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.storePanelCollapsed,
                        expression: "!storePanelCollapsed",
                      },
                    ],
                    staticClass: "store-list",
                  },
                  _vm._l(_vm.storeData, function (region) {
                    return _c(
                      "div",
                      { key: region.id },
                      [
                        _c("div", { staticClass: "region-title" }, [
                          _vm._v(_vm._s(region.label)),
                        ]),
                        _vm._v(" "),
                        _vm._l(region.children, function (store) {
                          return _c(
                            "div",
                            {
                              key: store.storeId,
                              staticClass: "store-item",
                              class: {
                                active: _vm.selectedStoreId === store.storeId,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleStoreSelect(store.storeId)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(store.label) +
                                  "\n            "
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    )
                  }),
                  0
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "template-panel",
                class: { collapsed: _vm.templatePanelCollapsed },
              },
              [
                _c("div", { staticClass: "panel-header" }, [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.templatePanelCollapsed,
                          expression: "!templatePanelCollapsed",
                        },
                      ],
                    },
                    [_vm._v("菜单分组")]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.templatePanelCollapsed,
                          expression: "templatePanelCollapsed",
                        },
                      ],
                      staticClass: "vertical-text",
                    },
                    [_vm._v("分组")]
                  ),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "collapse-icon",
                    class: _vm.templatePanelCollapsed
                      ? "el-icon-d-arrow-right"
                      : "el-icon-d-arrow-left",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.toggleTemplatePanel($event)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.templatePanelCollapsed,
                        expression: "!templatePanelCollapsed",
                      },
                    ],
                    staticClass: "template-panel-content",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "panel-subheader collapsible",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.toggleTemplateList($event)
                          },
                        },
                      },
                      [
                        _c("span", [_vm._v("模板列表")]),
                        _vm._v(" "),
                        _c("i", {
                          class: _vm.templateListCollapsed
                            ? "el-icon-arrow-down"
                            : "el-icon-arrow-up",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.templateListCollapsed,
                            expression: "!templateListCollapsed",
                          },
                        ],
                        staticClass: "template-list",
                      },
                      _vm._l(_vm.templateList, function (template) {
                        return _c(
                          "div",
                          {
                            key: template.id,
                            staticClass: "template-item",
                            class: {
                              active: _vm.currentTemplateId === template.id,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleTemplateSelect(template)
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "template-name" }, [
                              _vm._v(_vm._s(template.templateName)),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "template-info" }, [
                              _c("span", { staticClass: "template-type" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("menuTypeFilter")(template.type)
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              template.type === 2
                                ? _c("span", [
                                    _vm._v(
                                      "\n                  生效时间:\n                  "
                                    ),
                                    template.checkedWeekdays &&
                                    template.checkedWeekdays.indexOf(1) !== -1
                                      ? _c("span", [_vm._v("周一")])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    template.checkedWeekdays &&
                                    template.checkedWeekdays.indexOf(2) !== -1
                                      ? _c("span", [_vm._v("周二")])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    template.checkedWeekdays &&
                                    template.checkedWeekdays.indexOf(3) !== -1
                                      ? _c("span", [_vm._v("周三")])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    template.checkedWeekdays &&
                                    template.checkedWeekdays.indexOf(4) !== -1
                                      ? _c("span", [_vm._v("周四")])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    template.checkedWeekdays &&
                                    template.checkedWeekdays.indexOf(5) !== -1
                                      ? _c("span", [_vm._v("周五")])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    template.checkedWeekdays &&
                                    template.checkedWeekdays.indexOf(6) !== -1
                                      ? _c("span", [_vm._v("周六")])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    template.checkedWeekdays &&
                                    template.checkedWeekdays.indexOf(7) !== -1
                                      ? _c("span", [_vm._v("周日")])
                                      : _vm._e(),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              template.type === 2
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(template.beginTimeStr) +
                                        " - " +
                                        _vm._s(template.endTimeStr)
                                    ),
                                  ])
                                : _c("span", [_vm._v("全天有效")]),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "category-list-panel" }, [
                      _c(
                        "div",
                        {
                          staticClass: "category-list-header collapsible",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.toggleCategoryList($event)
                            },
                          },
                        },
                        [
                          _c("span", [_vm._v("菜单分类")]),
                          _vm._v(" "),
                          _c("i", {
                            class: _vm.categoryListCollapsed
                              ? "el-icon-arrow-down"
                              : "el-icon-arrow-up",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.categoryListCollapsed,
                              expression: "!categoryListCollapsed",
                            },
                          ],
                          staticClass: "category-list",
                        },
                        _vm._l(_vm.currentTemplateGroups, function (group) {
                          return _c(
                            "div",
                            {
                              key: group.id,
                              staticClass: "category-list-item",
                              class: {
                                active: _vm.selectedGroupId === group.id,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.scrollToGroup(group.id)
                                },
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(group.templateGroupName)),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "category-count" }, [
                                _vm._v(_vm._s(_vm.getGroupItemCount(group.id))),
                              ]),
                            ]
                          )
                        }),
                        0
                      ),
                    ]),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.listLoading,
                    expression: "listLoading",
                  },
                ],
                staticClass: "product-panel",
              },
              [
                _c("div", { staticClass: "channel-tabs" }, [
                  _c(
                    "div",
                    {
                      staticClass: "tab-item",
                      class: { active: _vm.activeScene === "1" },
                      on: {
                        click: function ($event) {
                          return _vm.handleSceneChange("1")
                        },
                      },
                    },
                    [_vm._v("\n            堂食\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "tab-item",
                      class: { active: _vm.activeScene === "2" },
                      on: {
                        click: function ($event) {
                          return _vm.handleSceneChange("2")
                        },
                      },
                    },
                    [_vm._v("\n            自提\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "tab-item",
                      class: { active: _vm.activeScene === "3" },
                      on: {
                        click: function ($event) {
                          return _vm.handleSceneChange("3")
                        },
                      },
                    },
                    [_vm._v("\n            外卖\n          ")]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { ref: "productContent", staticClass: "product-content" },
                  [
                    _vm.dataList.length === 0
                      ? _c("div", { staticClass: "empty-state" }, [
                          _c("i", { staticClass: "el-icon-s-shop empty-icon" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("请选择门店和模板查看商品")]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.dataList, function (group) {
                      return _c(
                        "div",
                        {
                          key: group.id,
                          staticClass: "category-section",
                          attrs: { id: "group-section-" + group.id },
                        },
                        [
                          _c("div", { staticClass: "category-header" }, [
                            _c("div", { staticClass: "category-name" }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(group.templateGroupName) +
                                  "\n                "
                              ),
                              group.regionCategory
                                ? _c(
                                    "span",
                                    { staticClass: "region-category" },
                                    [_vm._v(_vm._s(group.regionCategory))]
                                  )
                                : _vm._e(),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "category-actions" },
                              [
                                _c("el-switch", {
                                  attrs: {
                                    "active-color": "#13ce66",
                                    "inactive-color": "#ff4949",
                                    "active-value": 1,
                                    "inactive-value": 0,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.handleGroupStatusChange(
                                        $event,
                                        group
                                      )
                                    },
                                  },
                                  model: {
                                    value: group.groupStatus,
                                    callback: function ($$v) {
                                      _vm.$set(group, "groupStatus", $$v)
                                    },
                                    expression: "group.groupStatus",
                                  },
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "category-time" }, [
                                  _vm._v(
                                    _vm._s(group.beginTimeStr) +
                                      " - " +
                                      _vm._s(group.endTimeStr)
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          group.groupStatus === 1
                            ? [
                                _c(
                                  "el-table",
                                  {
                                    ref: "table_" + group.id,
                                    refInFor: true,
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      data: _vm.getVisibleItems(group),
                                      stripe: "",
                                    },
                                    on: {
                                      select: function (selection, row) {
                                        return _vm.handleRowSelect(
                                          selection,
                                          row,
                                          group
                                        )
                                      },
                                      "select-all": function (selection) {
                                        return _vm.handleSelectAllGroup(
                                          selection,
                                          group
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        type: "selection",
                                        width: "55",
                                        align: "center",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "明细id",
                                        prop: "id",
                                        align: "center",
                                        width: "80",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "商品名称",
                                        prop: "goodsName",
                                        align: "center",
                                        "min-width": "120",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "商品编码",
                                        prop: "goodsCode",
                                        align: "center",
                                        width: "100",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "菜品价格",
                                        align: "center",
                                        width: "100",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var row = ref.row
                                              return [
                                                _c(
                                                  "span",
                                                  { staticClass: "price" },
                                                  [
                                                    _vm._v(
                                                      "￥" +
                                                        _vm._s(row.marketPrice)
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "商品图",
                                        align: "center",
                                        width: "80",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var row = ref.row
                                              return [
                                                !row.goodsThumbnailUrl
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "product-img-placeholder",
                                                      },
                                                      [_vm._v("无图")]
                                                    )
                                                  : _c("el-image", {
                                                      staticStyle: {
                                                        width: "48px",
                                                        height: "48px",
                                                        "border-radius": "4px",
                                                      },
                                                      attrs: {
                                                        src:
                                                          _vm.resPath +
                                                          row.goodsThumbnailUrl,
                                                        fit: "cover",
                                                        "preview-src-list": [
                                                          _vm.resPath +
                                                            row.goodsThumbnailUrl,
                                                        ],
                                                        "preview-teleported":
                                                          "",
                                                      },
                                                    }),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "状态",
                                        align: "center",
                                        width: "80",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var row = ref.row
                                              return [
                                                _c("el-switch", {
                                                  attrs: {
                                                    "active-color": "#13ce66",
                                                    "inactive-color": "#ff4949",
                                                    "active-value": 1,
                                                    "inactive-value": 0,
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.handleStatusChange(
                                                        $event,
                                                        row
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value: row.status,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        row,
                                                        "status",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "row.status",
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "估清",
                                        align: "center",
                                        width: "180",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var row = ref.row
                                              return [
                                                _c("el-switch", {
                                                  attrs: {
                                                    "active-text": "已估清",
                                                    "inactive-text": "未估清",
                                                    "active-value": 1,
                                                    "inactive-value": 0,
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.handleEstimateFlag(
                                                        $event,
                                                        row
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value: row.estimateFlag,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        row,
                                                        "estimateFlag",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "row.estimateFlag",
                                                  },
                                                }),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "生效星期",
                                        align: "center",
                                        "min-width": "120",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var row = ref.row
                                              return [
                                                row.checkedWeekdays &&
                                                row.checkedWeekdays.indexOf(
                                                  1
                                                ) !== -1
                                                  ? _c("span", [_vm._v("周一")])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                row.checkedWeekdays &&
                                                row.checkedWeekdays.indexOf(
                                                  2
                                                ) !== -1
                                                  ? _c("span", [_vm._v("周二")])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                row.checkedWeekdays &&
                                                row.checkedWeekdays.indexOf(
                                                  3
                                                ) !== -1
                                                  ? _c("span", [_vm._v("周三")])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                row.checkedWeekdays &&
                                                row.checkedWeekdays.indexOf(
                                                  4
                                                ) !== -1
                                                  ? _c("span", [_vm._v("周四")])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                row.checkedWeekdays &&
                                                row.checkedWeekdays.indexOf(
                                                  5
                                                ) !== -1
                                                  ? _c("span", [_vm._v("周五")])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                row.checkedWeekdays &&
                                                row.checkedWeekdays.indexOf(
                                                  6
                                                ) !== -1
                                                  ? _c("span", [_vm._v("周六")])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                row.checkedWeekdays &&
                                                row.checkedWeekdays.indexOf(
                                                  7
                                                ) !== -1
                                                  ? _c("span", [_vm._v("周日")])
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "生效时间",
                                        align: "center",
                                        "min-width": "120",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var row = ref.row
                                              return [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(row.beginTimeStr) +
                                                    " - " +
                                                    _vm._s(row.endTimeStr) +
                                                    "\n                  "
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                    _vm._v(" "),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "操作",
                                        align: "center",
                                        width: "100",
                                        fixed: "right",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var row = ref.row
                                              return [
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      size: "mini",
                                                      type: "primary",
                                                      icon: "el-icon-edit",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.handleEdit(
                                                          row.id
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                      编辑\n                    "
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                group.items && group.items.length > 10
                                  ? _c(
                                      "div",
                                      { staticClass: "show-more-bar" },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: { type: "text" },
                                            on: {
                                              click: function ($event) {
                                                return _vm.toggleGroupExpand(
                                                  group.id
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("i", {
                                              class: _vm.isGroupExpanded(
                                                group.id
                                              )
                                                ? "el-icon-arrow-up"
                                                : "el-icon-arrow-down",
                                            }),
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.isGroupExpanded(group.id)
                                                    ? "收起"
                                                    : "展开更多 (" +
                                                        (group.items.length -
                                                          10) +
                                                        "条)"
                                                ) +
                                                "\n                "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            : _vm._e(),
                        ],
                        2
                      )
                    }),
                  ],
                  2
                ),
              ]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "商品编辑",
            visible: _vm.editVisible,
            size: "600px",
            direction: "rtl",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.editVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "editFormRef",
              staticClass: "dialog-form",
              staticStyle: { padding: "15px" },
              attrs: { model: _vm.editForm, "label-width": "120px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "商品名称", prop: "goodsName" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { autosize: "" },
                    model: {
                      value: _vm.editForm.goodsName,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "goodsName", $$v)
                      },
                      expression: "editForm.goodsName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "商品英文名", prop: "goodsNameEn" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: { autosize: "" },
                    model: {
                      value: _vm.editForm.goodsNameEn,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "goodsNameEn", $$v)
                      },
                      expression: "editForm.goodsNameEn",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "门店市场价", prop: "marketPrice" } },
                [
                  _c("el-input-number", {
                    staticStyle: { width: "300px" },
                    attrs: { autosize: "" },
                    on: { change: _vm.handleMarketPriceChange },
                    model: {
                      value: _vm.editForm.marketPrice,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "marketPrice", $$v)
                      },
                      expression: "editForm.marketPrice",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "单位价格", prop: "marketPrice" } },
                _vm._l(_vm.editForm.unitList, function (item) {
                  return _c(
                    "div",
                    { key: item.id },
                    [
                      _vm._v("\n          " + _vm._s(item.unitName) + ":"),
                      _c("el-input-number", {
                        staticStyle: { width: "270px" },
                        attrs: { autosize: "" },
                        on: {
                          change: function ($event) {
                            return _vm.handleUnitPriceChange(item.price)
                          },
                        },
                        model: {
                          value: item.price,
                          callback: function ($$v) {
                            _vm.$set(item, "price", $$v)
                          },
                          expression: "item.price",
                        },
                      }),
                    ],
                    1
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "菜品简介", prop: "goodsBrief" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 4, maxRow: 6 },
                    },
                    model: {
                      value: _vm.editForm.goodsBrief,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "goodsBrief", $$v)
                      },
                      expression: "editForm.goodsBrief",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "详细描述", prop: "goodsDesc" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 4, maxRow: 6 },
                    },
                    model: {
                      value: _vm.editForm.goodsDesc,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "goodsDesc", $$v)
                      },
                      expression: "editForm.goodsDesc",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "列表图" } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "upload-demo",
                      attrs: {
                        action: "#",
                        "on-remove": function (file, fileList) {
                          return _vm.handleRemoveFile(
                            file,
                            fileList,
                            "thumbnail"
                          )
                        },
                        "file-list": _vm.thumbnailFileList,
                        "http-request": function (options) {
                          return _vm.handlePictureUpload(options, "thumbnail")
                        },
                        "on-preview": _vm.handlePreview,
                        "list-type": "picture-card",
                        "auto-upload": true,
                        accept: "image/*",
                      },
                    },
                    [_c("i", { staticClass: "el-icon-plus" })]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "upload-tip" }, [
                    _vm._v("图片格式：jpg/png，大小≤2MB，尺寸305*402"),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "封面图" } },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "upload-demo",
                      attrs: {
                        action: "#",
                        "on-remove": function (file, fileList) {
                          return _vm.handleRemoveFile(file, fileList, "img")
                        },
                        "file-list": _vm.coverFileList,
                        "http-request": function (options) {
                          return _vm.handlePictureUpload(options, "img")
                        },
                        "on-preview": _vm.handlePreview,
                        "list-type": "picture-card",
                        "auto-upload": true,
                        accept: "image/*,video/mp4,video/3gpp,.m3u8",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "file",
                          fn: function (ref) {
                            var file = ref.file
                            return _c("div", {}, [
                              !file.isVideo
                                ? _c("img", {
                                    staticClass:
                                      "el-upload-list__item-thumbnail",
                                    attrs: { src: file.url, alt: "" },
                                  })
                                : _c(
                                    "div",
                                    { staticClass: "video-thumbnail-wrap" },
                                    [
                                      _c("video", {
                                        staticClass:
                                          "el-upload-list__item-thumbnail",
                                        attrs: {
                                          src: file.url,
                                          muted: "",
                                          preload: "metadata",
                                        },
                                        domProps: { muted: true },
                                      }),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-video-play video-play-icon",
                                      }),
                                    ]
                                  ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "el-upload-list__item-actions" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "el-upload-list__item-preview",
                                      on: {
                                        click: function ($event) {
                                          return _vm.handlePreview(file)
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-zoom-in",
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "el-upload-list__item-delete",
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleRemoveFile(
                                            file,
                                            _vm.coverFileList,
                                            "img"
                                          )
                                        },
                                      },
                                    },
                                    [_c("i", { staticClass: "el-icon-delete" })]
                                  ),
                                ]
                              ),
                            ])
                          },
                        },
                      ]),
                    },
                    [_c("i", { staticClass: "el-icon-plus" })]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "upload-tip" }, [
                    _vm._v(
                      "支持 jpg、png、gif、mp4、3gp、m3u8 格式，图片不超过2MB，视频不超过50MB，建议尺寸305*402"
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "生效时间", prop: "time" } },
                [
                  _c("el-time-picker", {
                    staticStyle: { width: "150px" },
                    attrs: {
                      placeholder: "起始时间",
                      format: "HH:mm",
                      "value-format": "HH:mm",
                    },
                    model: {
                      value: _vm.editForm.beginTimeStr,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "beginTimeStr", $$v)
                      },
                      expression: "editForm.beginTimeStr",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-time-picker", {
                    staticStyle: { width: "150px" },
                    attrs: {
                      placeholder: "结束时间",
                      format: "HH:mm",
                      "value-format": "HH:mm",
                    },
                    model: {
                      value: _vm.editForm.endTimeStr,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "endTimeStr", $$v)
                      },
                      expression: "editForm.endTimeStr",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "生效星期", prop: "weekdays" } },
                [
                  _c(
                    "el-checkbox",
                    { on: { change: _vm.handleCheckAllChange } },
                    [_vm._v("全选")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticStyle: { margin: "15px 0" } }),
                  _vm._v(" "),
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.editForm.checkedWeekdays,
                        callback: function ($$v) {
                          _vm.$set(_vm.editForm, "checkedWeekdays", $$v)
                        },
                        expression: "editForm.checkedWeekdays",
                      },
                    },
                    _vm._l(_vm.weekdays, function (day) {
                      return _c(
                        "el-checkbox",
                        { key: day.value, attrs: { label: day.value } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(day.label) +
                              "\n          "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "自动同步", prop: "autoSyncFlag" } },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-text": "开启",
                      "inactive-text": "关闭",
                      "active-value": 1,
                      "inactive-value": 0,
                    },
                    model: {
                      value: _vm.editForm.autoSyncFlag,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "autoSyncFlag", $$v)
                      },
                      expression: "editForm.autoSyncFlag",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "upload-tip" }, [
                    _vm._v("开启后，菜品库修改商品信息将自动同步到该门店菜单"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "drawer-footer" },
            [
              _c("el-button", { on: { click: _vm.handleCancelEdit } }, [
                _vm._v("取消"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.saveEntity()
                    },
                  },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "预览门店菜单",
            visible: _vm.previewDialogVisible,
            width: "400px",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.previewLoading,
                  expression: "previewLoading",
                },
              ],
              staticClass: "preview-qrcode-container",
            },
            [
              _c("div", { staticClass: "preview-info" }, [
                _c("p", [
                  _c("strong", [_vm._v("门店ID：")]),
                  _vm._v(_vm._s(_vm.selectedStoreId)),
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("strong", [_vm._v("模板ID：")]),
                  _vm._v(_vm._s(_vm.currentTemplateId)),
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("strong", [_vm._v("当前场景：")]),
                  _vm._v(_vm._s(_vm.getSceneLabel(_vm.activeScene))),
                ]),
              ]),
              _vm._v(" "),
              _vm.previewQrCode
                ? _c(
                    "div",
                    { staticClass: "qrcode-wrapper" },
                    [
                      _c(
                        "el-image",
                        {
                          staticStyle: { width: "280px", height: "280px" },
                          attrs: { src: _vm.previewQrCode, fit: "contain" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "image-slot",
                              attrs: { slot: "placeholder" },
                              slot: "placeholder",
                            },
                            [
                              _c("i", { staticClass: "el-icon-loading" }),
                              _vm._v(" "),
                              _c("span", [_vm._v("加载中...")]),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "preview-tip" }, [
                _c("p", [
                  _vm._v("使用微信扫描二维码，在小程序中预览门店菜单效果"),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.previewDialogVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.downloadQrCode },
                },
                [_vm._v("下载二维码")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.previewMediaDialog.isVideo ? "视频预览" : "图片预览",
            visible: _vm.previewMediaDialog.visible,
            width: "600px",
            "append-to-body": "",
            "destroy-on-close": true,
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.previewMediaDialog, "visible", $event)
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "text-align": "center",
                display: "flex",
                "justify-content": "center",
                "align-items": "center",
                "min-height": "200px",
              },
            },
            [
              _vm.previewMediaDialog.isVideo
                ? _c("video", {
                    staticStyle: {
                      "max-width": "100%",
                      "max-height": "65vh",
                      "border-radius": "4px",
                    },
                    attrs: {
                      src: _vm.previewMediaDialog.url,
                      controls: "",
                      autoplay: "",
                    },
                  })
                : _c("img", {
                    staticStyle: {
                      "max-width": "100%",
                      "max-height": "65vh",
                      "object-fit": "contain",
                      "border-radius": "4px",
                    },
                    attrs: { src: _vm.previewMediaDialog.url, alt: "预览图" },
                  }),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }